import { WidgetBase, HasWidgetPermissions, LocalWidgetRouter } from '@/core/widgets/export';
import { SidePanelId } from '@/core/deep-dive/contexts/side-panel-provider';
import PanelWidgetContainerContext from '@/core/deep-dive/contexts/side-panel-container-context';

export default function WidgetPane({
  widget,
  panelId,
  path,
  onNavigate,
}: {
  widget: WidgetBase;
  panelId: SidePanelId;
  path?: string;
  onNavigate?: (path: string) => void;
}) {
  return (
    <PanelWidgetContainerContext widget={widget} panelId={panelId}>
      <HasWidgetPermissions widget={widget}>
        <LocalWidgetRouter widget={widget} path={path} onNavigate={onNavigate ?? (() => {})} />
      </HasWidgetPermissions>
    </PanelWidgetContainerContext>
  );
}
